export class Alert {
  imei: number;
  type: string;
  tracker_id: number;

  extras: {
    source_type: string;
    source_id: number;
    phone_number: string;
  };

  server_date: Date;
  created_at: Date;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/alert.entity.ts